import { useMutationCallback } from 'shared/api/hooks';
import { User } from 'z3k-config';
import { getDeviceSpecV2 } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { Z3KSettingsUpdateReason } from 'z3k-settings/redux/actions';
import { useMemo } from 'react';
export function useSaveTrustTelephones(device) {
    const [onSaveDeviceConfig, loadingSaveDeviceConfig, responseSaveDeviceConfig, errorSaveDeviceConfig, sendSaveDeviceConfig,] = useMutationCallback('update_device');
    const [onSaveZ3kConfig, loadingSaveZ3kConfig, responseSaveZ3kConfig, errorSaveZ3kConfig, sendSaveZ3kConfig,] = useMutationCallback('save_z3k_config');
    const device_spec = useMemo(() => getDeviceSpecV2(device.device_type?.code, device.hardware_type?.code), [device.device_type, device.hardware_type]);
    const result = useMemo(() => {
        if (device_spec == null) {
            return [
                (telephones, password) => {
                    const device_setter = {
                        tel_password: password,
                        trusted_phones: telephones.toString().replace(/[^0-9,+]/g, ''),
                    };
                    return onSaveDeviceConfig({ device_id: device.id, ...device_setter });
                },
                loadingSaveDeviceConfig,
                responseSaveDeviceConfig,
                errorSaveDeviceConfig,
                sendSaveDeviceConfig,
            ];
        }
        else {
            return [
                (telephones, password) => {
                    const device_setter = {
                        tel_password: password,
                        trusted_phones: telephones.toString().replace(/[^0-9,+]/g, ''),
                    };
                    let config = device.z3k_config;
                    if (config != null) {
                        //Добавляем телефон
                        if (device_setter.tel_password ||
                            device_setter.trusted_phones) {
                            config = User.get.add(config, {
                                ...User.default_object,
                                phone: device_setter.trusted_phones ?? '',
                                password: device_setter.tel_password ?? '',
                            })[1];
                            return onSaveZ3kConfig({
                                device_id: device.id,
                                config,
                                commands: [],
                                reason: Z3KSettingsUpdateReason.SaveTrustPhones,
                            });
                        }
                    }
                    else {
                        throw new Error('not found z3k config');
                    }
                },
                loadingSaveZ3kConfig,
                responseSaveZ3kConfig,
                errorSaveZ3kConfig,
                sendSaveZ3kConfig,
            ];
        }
    }, [device_spec]);
    return result;
}
